import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SidebarComponent } from './sidebar/sidebar.component';
import { NavbarComponent } from './navbar/navbar.component';
import { FooterComponent } from './footer/footer.component';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { DateComponent } from './date/date.component';
import { DualSelectionComponent } from './dual-selection/dual-selection.component';
import { FormsModule } from '@angular/forms';
import { ExportComponent } from './export/export.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    NgbModule,
    FormsModule,
  ],
  declarations: [
    FooterComponent,
    NavbarComponent,
    SidebarComponent,
    DateComponent,
    DualSelectionComponent,
    ExportComponent,
  ],
  exports: [
    FooterComponent,
    NavbarComponent,
    SidebarComponent,
    DateComponent,
    DualSelectionComponent
  ]
})
export class ComponentsModule { }
